// extracted by mini-css-extract-plugin
module.exports = {"card":"ContractAvaliation_card__-M--R","container":"ContractAvaliation_container__eftDZ","fadeIn":"ContractAvaliation_fadeIn___H6VA","fadeOut":"ContractAvaliation_fadeOut__3jBBU"};